import { DEFAULT_PAGE_SIZE, METHOD_AXIOS } from '../utils/constant'
import { BaseApi } from './base.api'

export class FeedbackApi extends BaseApi {
	constructor() {
		super('')
	}

	async getAllFeedback(page, pageSize = DEFAULT_PAGE_SIZE) {
		const rs = await this.get(
			`api/feedback/all?pageNum=${page}&pageSize=${pageSize}`
		)
		return rs
	}

	async updateFeedback(data) {
		const rs = await this.methodWithFormDataUrlEncoded(
			`api/feedback`,
			data,
			METHOD_AXIOS.PUT
		)
		return rs
	}
	async addReply(data) {
		const rs = await this.methodWithFormDataUrlEncoded(
			`api/feedback/reply`,
			data,
			METHOD_AXIOS.POST
		)
		return rs
	}
}
